<template>
  <div>
    <div class="input-container">

      <el-input style="margin-right: 50px;" v-model="roomNum" :placeholder="$t('conferenceLog.inputPlaceholder')"
        class="custom-input"></el-input>
      <el-button style="width: auto; padding-left: 15px; padding-right: 15px;" type="primary" @click="search">{{ $t('button.search') }}</el-button>
      <el-button style="width: auto; padding-left: 15px; padding-right: 15px;" type="primary" @click="clear">{{ $t('button.clear') }}</el-button>

    </div>

    <div class="table-container">

      <el-table :data="tableData" border  style="width: 1100px">
        <el-table-column prop="roomId" :label="$t('conferenceLog.table.th.roomId')" width="160">
          <template slot-scope="scope">
            <div class="room-link" @click="handleRoomClick(scope.row.participantsLog)">{{ scope.row.roomId }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="state" :label="$t('conferenceLog.table.th.state')">

          <template slot-scope="scope">{{ formatState(scope.row.state) }}</template>
        </el-table-column>
        <el-table-column prop="username" :label="$t('conferenceLog.table.th.username')" width="340">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('conferenceLog.table.th.createTime')" width="180">

          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column prop="closeTime" :label="$t('conferenceLog.table.th.closeTime')" width="130">

          <template slot-scope="scope">{{ formatHMSTime(scope.row.closeTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('conferenceLog.table.th.duration')" width="150">

          <template slot-scope="scope">{{ timeLong(scope.row.createTime, scope.row.closeTime) }}</template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="dataCount" class="pagination-right-aligned">
      </el-pagination>

    </div>




    <el-dialog :title="$t('conferenceLog.dialog.title')" :visible.sync="participantsLogDialogVisible" width="50%"
      center>

      <el-table :data="participantsLogTableData" border style="width: 100%">
        <el-table-column prop="username" :label="$t('conferenceLog.dialog.table.th.username')" width="330">
        </el-table-column>

        <el-table-column prop="joinTime" :label="$t('conferenceLog.dialog.table.th.joinTime')" width="180">

          <template slot-scope="scope">{{ formatTime(scope.row.joinTime) }}</template>
        </el-table-column>

        <el-table-column prop="leaveTime" :label="$t('conferenceLog.dialog.table.th.leaveTime')" width="120">

          <template slot-scope="scope">{{ formatHMSTime(scope.row.leaveTime) }}</template>
        </el-table-column>

        <el-table-column :label="$t('conferenceLog.dialog.table.th.duration')">

          <template slot-scope="scope">{{ timeLong(scope.row.joinTime, scope.row.leaveTime) }}</template>
        </el-table-column>
      </el-table>

    </el-dialog>

  </div>
</template>

<script>

import { methodGet } from '@/api'
// eslint-disable-next-line no-unused-vars
// 抽象公共函数失败
// import { formatTime, formatHMSTime, timeLong } from '@/components/js/commonUtils'

export default {
  created() {
    this.loadConferenceLogList()
  },
  data() {
    return {
      tableData: [],
      participantsLogTableData: [],
      pageIndex: 1,
      pageSize: 10,
      dataCount: 0,
      participantsLogDialogVisible: false,
      roomNum: ''
    }
  },
  methods: {
    search() {
      this.loadConferenceLogList()
    },
    clear() {
      this.roomNum = ''
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.loadConferenceLogList()
    },
    handleCurrentChange(page) {
      this.pageIndex = page
      this.loadConferenceLogList()
    },
    loadConferenceLogList() {
      const params = {
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          roomNum: this.roomNum
        }
      }
      methodGet('/api/callLog/conference', params).then((data) => {
        if (data.status) {
          this.dataCount = data.data.dataCount
          this.tableData = data.data.datas
        }
      })
    },
    formatState(state) {
      if (state == 'create') {
        return 'ongoing'
      }
      return state
    },
    formatHMSTime(time) {
      if (time == null || time == 0) {
        return ''
      }
      const date = new Date(time).toLocaleString()
      return date.match(/\d+:\d+:\d+/)[0]
    },
    formatTime(time) {
      // eslint-disable-next-line use-isnan
      if (time == null || time == NaN || time == '') {
        return ''
      }
      return this.chgUnintimestr(time / 1000)
    },
    handleRoomClick(participantsLog) {
      this.participantsLogDialogVisible = true
      this.participantsLogTableData = participantsLog
    },
    chgUnintimestr(time) {
      const unixTimestamp = new Date(time * 1000)
      return unixTimestamp.toLocaleString()
    },
    timeLong(callTime, endTime) {
      if (callTime == null || callTime == '') {
        return ''
      }
      if (endTime == null || endTime == '') {
        return ''
      }
      return this.sec2timeLong(Math.floor((endTime - callTime) / 1000), 1, 0)
    },
    sec2timeLong(sec, dispSec, ch) {
      let str = ''
      if (sec >= 3600) {
        str = Math.floor(sec / 3600) + (ch ? '小时' : ':')
        // eslint-disable-next-line no-param-reassign
        sec = sec % 3600
      }
      if (sec >= 60) {
        str = str + (Math.floor(sec / 60) + (ch ? '分' : '\''))
        // eslint-disable-next-line no-param-reassign
        sec = sec % 60
      }
      if (dispSec) {
        str = str + (sec + (ch ? '秒' : '"'))
      }
      return str
    }
  }
}
</script>

<style scoped>
.input-container {
  /* display: inline-block; */
  margin-bottom: 20px;
}

.custom-input {
  width: 200px;
}

.pagination-right-aligned {
  margin-top: 15px;
  text-align: right;
}

.room-link {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}

.table-container {
  position: relative;
  width: 1100px; /* 设置表格容器的宽度 */
}
</style>
